// extracted by mini-css-extract-plugin
export var closeButton = "_74-0";